/**
 * 카테고리 enum → 한글 라벨 매핑.
 *
 * lead_item.category, SEARCH_CATALOG_SOURCES.name 과 정렬되어 있어야 함.
 * 새 카탈로그 추가 시 여기와 백엔드 CHECK 제약 둘 다 갱신 필요.
 */

export type CategoryKey =
  | 'chassis'
  | 'cpu'
  | 'gpu'
  | 'memory'
  | 'ssd'
  | 'hdd'
  | 'network_adapter'
  | 'hba'
  | 'raid_controller'
  | 'power_supply'
  | 'pre_configured_model'
  | 'other';

/** key → 한글 라벨 (드롭다운 표시용) */
export const CATEGORY_LABEL: Record<CategoryKey, string> = {
  chassis:              '섀시',
  cpu:                  'CPU',
  gpu:                  'GPU',
  memory:               '메모리',
  ssd:                  'SSD',
  hdd:                  'HDD',
  network_adapter:      '네트워크 어댑터',
  hba:                  'HBA',
  raid_controller:      'RAID 컨트롤러',
  power_supply:         '파워서플라이',
  pre_configured_model: '사전 구성 모델',
  other:                '기타',
};

/** 드롭다운 옵션 배열 (순서 유지) */
export const CATEGORY_OPTIONS: ReadonlyArray<{
  value: CategoryKey;
  label: string;
}> = [
  { value: 'chassis',              label: CATEGORY_LABEL.chassis },
  { value: 'cpu',                  label: CATEGORY_LABEL.cpu },
  { value: 'gpu',                  label: CATEGORY_LABEL.gpu },
  { value: 'memory',               label: CATEGORY_LABEL.memory },
  { value: 'ssd',                  label: CATEGORY_LABEL.ssd },
  { value: 'hdd',                  label: CATEGORY_LABEL.hdd },
  { value: 'network_adapter',      label: CATEGORY_LABEL.network_adapter },
  { value: 'hba',                  label: CATEGORY_LABEL.hba },
  { value: 'raid_controller',      label: CATEGORY_LABEL.raid_controller },
  { value: 'power_supply',         label: CATEGORY_LABEL.power_supply },
  { value: 'pre_configured_model', label: CATEGORY_LABEL.pre_configured_model },
  { value: 'other',                label: CATEGORY_LABEL.other },
];

/** 검색 API 의 source 문자열을 category key 로 변환 (대부분 1:1, 안전망). */
export function sourceToCategory(source: string): CategoryKey {
  return (CATEGORY_LABEL as Record<string, string>)[source]
    ? (source as CategoryKey)
    : 'other';
}

/** category key 가 유효한지 검사 (자유 텍스트 → 안전한 enum 변환). */
export function isCategoryKey(value: string): value is CategoryKey {
  return value in CATEGORY_LABEL;
}

/** category key 의 한글 라벨, 미지정/잘못된 키는 빈 문자열. */
export function labelForCategory(key: string | null | undefined): string {
  if (!key) return '';
  return isCategoryKey(key) ? CATEGORY_LABEL[key] : '';
}
